import { apiRequest } from './client';
import type { CurrentUser } from './auth';

export type MyProfileUpdatePayload = {
  readonly full_name?: string;
  readonly first_name?: string;
  readonly last_name?: string;
  readonly phone_number?: string;
  readonly telegram_username?: string;
};

export type ChangePasswordPayload = {
  readonly current_password: string;
  readonly new_password: string;
};

export function updateMyProfile(
  payload: MyProfileUpdatePayload,
  accessToken: string,
): Promise<CurrentUser> {
  return apiRequest<CurrentUser>('/auth/me', {
    method: 'PATCH',
    body: payload,
    token: accessToken,
  });
}

export function uploadMyAvatar(file: File, accessToken: string): Promise<CurrentUser> {
  const formData = new FormData();
  formData.append('file', file);
  return apiRequest<CurrentUser>('/auth/me/avatar', {
    method: 'POST',
    body: formData,
    token: accessToken,
  });
}

export function deleteMyAvatar(accessToken: string): Promise<CurrentUser> {
  return apiRequest<CurrentUser>('/auth/me/avatar', {
    method: 'DELETE',
    token: accessToken,
  });
}

export function changeMyPassword(
  payload: ChangePasswordPayload,
  accessToken: string,
): Promise<void> {
  return apiRequest<void>('/auth/change-password', {
    method: 'POST',
    body: payload,
    token: accessToken,
  });
}
